module.exports = __webpack_public_path__ + "media/images/athletes/426-84f2b2530aeda0f6234664fec833f251.png";